import { useCallback, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { Select } from "antd";
import { useAuth } from "context/AuthContext";
import { MessagesDefaultTimeout } from "constants/messagesDefaultTimeout";
import CONSTANTES_AMBIENTE from "constants/constantesAmbiente";
import UsuariosService from "services/UsuariosService";
import DireitosPortalService from "services/DireitosPortalService";
import FormulariosEntidadeService from "services/FormulariosEntidadeService";
import AssessoresService from "services/AssessoresService";
import ConsultoresService from "services/ConsultoresService";
import DominiosService from "services/DominiosService";
import EmailsService from "services/EmailsService";
import { createCheckboxInput, createDividerConfig, createHiddenInput, createPhoneInput, createTableContainerWithCustomForm, createTableInput, createTextInput, createTextSufixoInput, updateInputStatus } from "utils/FormularioHelper";
import PortalGerenciadorDePerfis from 'components/Formulario/Components/SubComponents/PortalGerenciadorDePerfis';
import { ModalAviso } from "components/Modais/ModalAviso";
import getAccountById from "EstruturaAntiga/actions/account/getAccountById";

export const useUsuarioRestaurar = ({form, usuarioId}) => {
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(true);

    const [initialValues, setInitialValues] = useState({});
    const [inputs, setInputs] = useState([]);
    const [sufixos, setSufixos] = useState([]);
    const {contato, tenant, direito} = useAuth()
    const [configuracoesFormulario, setConfiguracoesFormulario] = useState([])

    useEffect(() => {        
        if (usuarioId) {
            obterDadosUsuario(usuarioId, tenant.tenantCode);
        } else {
            NotificationManager.error('ID do usuário não encontrado.', 'Erro!', MessagesDefaultTimeout.Error);
            setHasError(true);
            setLoading(false);
        }
    }, [usuarioId]);

    useEffect(() => {
        if(configuracoesFormulario.length == 0 || Object.keys(initialValues).length == 0) return
        AtualizarInputsFormularioDados();
    }, [initialValues, configuracoesFormulario]);

    const AtualizarInputsFormularioDados = () =>{
        const inputs = gerarInputsFormulario();
        setInputs(inputs);
    }
    const obterDadosUsuario = async (id, tenantCode) => {
        Promise.all([
            UsuariosService.ObterUsuarioExcluido(id, tenantCode),
            FormulariosEntidadeService.ListarCamposMapeadosNoPortal(),
            DominiosService.ListarSufixosPorCliente(),
            getAccountById()
        ])
        .then(([usuario, camposPortal, sufixos, account]) => {
            setConfiguracoesFormulario(camposPortal)
            setSufixos(sufixos)
            const configDoCampoMFA = camposPortal.find(campo => campo.campoPortalCliente.nome.toLowerCase() === "habilitarMFA".toLowerCase());
            const perfisIniciais = usuario.perfis || [];
            const [dominio, dominioSufixo] = usuario.emailPrincipal ? usuario.emailPrincipal.split('@') : ['', ''];
            setInitialValues({ 
                ...usuario, 
                nomeEmpresa: direito.accountName || "",
                perfis: perfisIniciais.map(p => p.id),
                dominio,
                dominioSufixo,
                razaoSocial: account.axt_razaosocial || "",
                cnpj: account.axt_cnpjview || "",
                codigoCliente: account.accountnumber || "",
                usuarioId: id,
                usuarioAssessor: (tenant.formId == CONSTANTES_AMBIENTE.FORMULARIO_USUARIOS.CONSULTORES_XP),
                emailAlternativo: "",
                telefoneComercial: usuario.telefoneComercial || "",
                telefoneCelular: "",
                habilitarMFA: configDoCampoMFA?.somenteLeitura ? true : false
            });
            setLoading(false);
        })
        .catch((error) => {
            NotificationManager.error('Não foi possível buscar os dados do usuário.', 'Erro!', MessagesDefaultTimeout.Error);
            setHasError(true);
            setLoading(false);
        });
    };

    const listarDireitos = useCallback(async () => {
        const contactId = contato.idContact;
        return await DireitosPortalService.ListarDireitosPorContato(contactId, CONSTANTES_AMBIENTE.PERFIL_ACESSO.ADMINISTRADOR_SERVICOS)
    },[])

    const atualizarStatusCampo = (nomeCampo, status, mensagem) => {
        setInputs(prevInputs => {
            return updateInputStatus(prevInputs, nomeCampo, status, mensagem)
        });
    };

    const ValidaObrigatoriedadeInput = (nomeAtributo) => {
        const configDoCampo = configuracoesFormulario.find(campo => campo.campoPortalCliente.nome.toLowerCase() == nomeAtributo.toLowerCase())
        if(!configDoCampo){
            return false
        }
        return configDoCampo.obrigatorio
    }

    const ValidaVisibilidadeInput = (nomeAtributo) => {
        const configDoCampo = configuracoesFormulario.find(campo => campo.campoPortalCliente.nome.toLowerCase() == nomeAtributo.toLowerCase())
        if(!configDoCampo){
            return false
        }
        return !configDoCampo.oculto
    }

    const adicionarInputSeVisivel = (nome, createFn) => {
        return ValidaVisibilidadeInput(nome) ? [createFn()] : [];
    };

    const gerarInputsFormulario = () => { 
        const campoCodigoAssessor = configuracoesFormulario.find(campo => campo.campoPortalCliente.nome.toLowerCase() == "AtributoEstendido5".toLowerCase())
        const deveRestringirPerfis = campoCodigoAssessor && !campoCodigoAssessor.oculto;


        const tableContainer = createTableContainerWithCustomForm("Novo perfil", <PortalGerenciadorDePerfis/>, {
            listaPerfisAcesso: [],
            listaDireitos: listarDireitos(),
            deveRestringirPerfis: deveRestringirPerfis
        });
        const selectSufixoOptions = sufixos.map(
            sufixo => <Select.Option key={sufixo} value={sufixo}>@{sufixo}</Select.Option>
        );
        const perfisDataSource = initialValues.perfis?.map(id => ({ id, nome: `Perfil ${id}` })) || [];
        return [
            createHiddenInput('usuarioId'),
            createTextInput('nomeEmpresa', 'Empresa', { required: false, disabled: true }, {}, createDividerConfig("Informações da Empresa")),
            createTextInput('razaoSocial', 'Razão Social', { required: false, disabled: true }, { colSpan: 12 }),
            createTextInput('cnpj', 'CNPJ', { required: false, disabled: true },{ colSpan: 12 }),
            ...adicionarInputSeVisivel("nome", ()=>
                createTextInput('nome', "Nome", {required: ValidaObrigatoriedadeInput('nome')}, { colSpan: 12 }, createDividerConfig("Dados do usuário")),
            ),
            ...adicionarInputSeVisivel("sobrenome", ()=>
                createTextInput('sobrenome', 'Sobrenome', {required: ValidaObrigatoriedadeInput('sobrenome')},{ colSpan: 12, hidden: true }),
            ),
            ...adicionarInputSeVisivel("nomeParaExibicao", ()=>
                createTextInput('nomeParaExibicao', 'Nome de Exibição', {required: ValidaObrigatoriedadeInput('nomeParaExibicao')},{ colSpan: 12 }),
            ),
            ...adicionarInputSeVisivel("telefoneCelular", ()=>
                createPhoneInput('telefoneCelular', 'Celular', {required: ValidaObrigatoriedadeInput('telefoneCelular')},{ colSpan: 12}),
            ),
            ...adicionarInputSeVisivel("telefoneComercial", ()=>
                createPhoneInput('telefoneComercial', 'Telefone', {required: ValidaObrigatoriedadeInput('telefoneComercial')},{ colSpan: 12}),
            ),
            ...adicionarInputSeVisivel("emailAlternativo", ()=>
                createTextInput('emailAlternativo', 'Email Alternativo', { required: ValidaObrigatoriedadeInput('emailAlternativo'), rules: [{ type: 'email', message: 'E-mail inválido' }], onBlur: (e) => handleInputBlur('emailAlternativo', e.target.value) },{ colSpan: 12 }),
            ),
            ...adicionarInputSeVisivel("departamento", ()=>
                createTextInput('departamento', 'Departamento', {required: ValidaObrigatoriedadeInput("departamento")},{ colSpan: 12 }),
            ),
            ...adicionarInputSeVisivel("cargo", ()=>
                createTextInput('cargo', 'Cargo', {required: ValidaObrigatoriedadeInput("cargo")},{ colSpan: 12}),
            ),
            ...gerarInputCodigoAssessor(),
            ...adicionarInputSeVisivel("habilitarMFA", ()=>
                gerarInputHabilitarMFA(),
            ),
            createTextSufixoInput('dominio', 'E-mail',{}, { selectSufixoOptions },{}),
            createTableInput('perfis', 'Perfis de Acesso ao Atendimento', colunas, tableContainer, {required: true}, { dataSource: perfisDataSource },createDividerConfig(<>Perfis de Acesso ao Atendimento <span style={{color: 'red'}}>*</span></>)),
        ];
    };

    const gerarInputCodigoAssessor = () =>{
        const campoCodigoAssessor = configuracoesFormulario.find(campo => campo.campoPortalCliente.nome.toLowerCase() == "AtributoEstendido5".toLowerCase())
        var inputs = []
        if(campoCodigoAssessor && !campoCodigoAssessor.oculto){
            GerarCampoCheckBox();
            GerarCampoCodigoAssessor();
        }
        return inputs;

        
        function GerarCampoCheckBox() {
            var inputPropsCheckbox = {};
            if (tenant.formId == CONSTANTES_AMBIENTE.FORMULARIO_USUARIOS.CONSULTORES_XP) {
                inputPropsCheckbox.disabled = true;
            }
            var checkbox = createCheckboxInput('usuarioAssessor', "Usuário Assessor", { ...inputPropsCheckbox }, { colSpan: 12 });
            inputs.push(checkbox);
        }

        function GerarCampoCodigoAssessor() {
            var usuarioAssessor = form.getFieldValue("usuarioAssessor");
            if (usuarioAssessor == true) {
                var input = createTextInput('codigoAssessor', 'Código Assessor', {
                    required: true,
                    hasFeedback: true,
                    onBlur: (e) => handleInputBlur('codigoAssessor', e.target.value)
                }, { colSpan: 12 });
            
                inputs.push(input);
            }else{
                form.setFieldValue("codigoAssessor", null)
            }
        }
    }

    const gerarInputHabilitarMFA = () => {
        const configDoCampo = configuracoesFormulario.find(campo => campo.campoPortalCliente.nome.toLowerCase() == "habilitarMFA".toLowerCase())
        const textoTooltip = configDoCampo?.somenteLeitura ? "Para garantir a segurança do ambiente, o MFA é obrigatório e não pode ser desabilitado." :
			"Recomendamos manter o MFA habilitado, pois ele ajuda a proteger sua conta exigindo uma segunda etapa de verificação, dificultando acessos não autorizados, mesmo que sua senha seja comprometida.";

        var checkbox = createCheckboxInput('habilitarMFA', "Habilitar MFA", { disabled: !!configDoCampo?.somenteLeitura}, { colSpan: 12,tooltip: textoTooltip });
        return checkbox
    }

    const handleInputBlur = async (fieldName, value) => {
        if (fieldName === 'codigoAssessor') {
            ValidarCodigoAssessor(value)
        }
        else if(fieldName == "emailAlternativo"){
            ValidarEmailAlternativo(value)
        }
    };

    const handleOnValuesChange = (changedValues, allValues) =>{
        if(Object.keys(changedValues).some(x=>x=="usuarioAssessor")){
            AtualizarInputsFormularioDados()
        }

        if (changedValues.nome !== undefined || changedValues.sobrenome !== undefined) {
            const nome = allValues.nome || '';
            const sobrenome = allValues.sobrenome || '';
            form.setFieldValue('nomeParaExibicao', `${nome} ${sobrenome}`.trim());
        }
    }

    const portalOnInputSufixosValueChange = (a,b) =>{
        var dominio = form.getFieldValue("dominio")
        var dominioSufixo = form.getFieldValue("dominioSufixo")
        if(dominio && dominioSufixo){
            let email = dominio + '@' + dominioSufixo;
            ValidarEmailPrincipal(email)
        }else{
            atualizarStatusCampo("dominio", '', '');
        }
    }

    const colunas = [{
            title: 'Contrato de Serviço', width: '250px',
            render: (_, record) => `${record.direito.label}`,
        },
        { 
            title: 'Perfil de Acesso', width: '100px',
            render: (_, record) => `${record.perfil.label}`
        }
    ]

    const ValidarEmailPrincipal = async (email) => {
        if (!email) {
            atualizarStatusCampo("dominio", '', '');
            return true;
        }
        atualizarStatusCampo("dominio", 'validating', 'Validando email...');
        try {
            await EmailsService.ValidarEmailPrincipal(email, false);
            atualizarStatusCampo("dominio", 'success', 'Email válido!');
            return true;
        } catch (error) {
            atualizarStatusCampo("dominio", 'error', 'Email indisponível.');
            return false;
        }
    }

    const ValidarEmailAlternativo = async (email) => {
        if (!email) {
            atualizarStatusCampo("emailAlternativo", '', '');
            return;
        }
        atualizarStatusCampo("emailAlternativo", 'validating', 'Validando email...');
        await EmailsService.ValidarEmailAlternativo(email)
        .then(() =>{
            atualizarStatusCampo("emailAlternativo", 'success', 'Email válido!');
        })
        .catch((error) => {
            atualizarStatusCampo("emailAlternativo", 'error', 'Email inválido.');
        })
    }

    const ValidarCodigoAssessor = async(value) =>{
        if (!value) {
            atualizarStatusCampo("codigoAssessor", '', '');
            return;
        }
        atualizarStatusCampo("codigoAssessor", 'validating', 'Validando código...');
        
        const promise = tenant.formId == CONSTANTES_AMBIENTE.FORMULARIO_USUARIOS.CONSULTORES_XP
            ? ConsultoresService.ChecarCodigoConsultor(value)
            : AssessoresService.ChecarCodigoAssessor(value);

        promise
            .then((response) => {
                if (+response.resultCode === 1) {
                    atualizarStatusCampo("codigoAssessor", 'success', 'Código válido!');
                } else if (+response.resultCode === 0) {
                    ModalAviso({
                        titulo: 'Código de assessor já utilizado por outro usuário. Deseja utilizar mesmo assim?',
                        conteudo: value,
                        onOk: () => {
                            atualizarStatusCampo("codigoAssessor", 'success', '');
                        },
                        onCancel: () => {
                            atualizarStatusCampo("codigoAssessor", 'error', 'Código de assessor já utilizado por outro usuário.');
                            form.setFieldValue("codigoAssessor", null);
                        }
                    });
                } else {
                    atualizarStatusCampo("codigoAssessor", 'error', response.message || 'Código de assessor inválido.');
                }
            })
            .catch(() => {
                atualizarStatusCampo("codigoAssessor", 'error', 'Código de assessor inválido.');
            });
    }

    const getCampoStatus = (nomeCampo) => {
        const campoConfig = inputs.find(i => i.input.name === nomeCampo);
        return campoConfig?.input.validateStatus;
    };
    
    return{
        formularioProps:{
            initialValues,
            inputs,
            onValuesChange: handleOnValuesChange,
            portalOnInputSufixosValueChange
        },
        validarEmail: ValidarEmailPrincipal,
        getCampoStatus,
        hasError,
        loading
    }
}
